import React from "react";

export const ErrorPage = () => <div>Some error occoured</div>;
